import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { CountryDataTimeline, CountryDataTimelineCommentDto } from "../models/countrydatatimeline";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

/**
 * @whatItDoes A service for anything item related
 *
 * @howToUse Inject the service
 */
@Injectable()
export class CountryDataTimelineEventService extends BaseService {
    /**
     * Constructor for service
     * @param http angular http module
     * @param toastr toastr manager
     * @param store ngrx store
     */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Save the modified changes (as draft) and return the updated configset with correctly assigned IDs.
     * @param countryDataTimelineEvent
     */
    create(countryDataTimelineEvent: CountryDataTimelineCommentDto): Observable<CountryDataTimeline[]> {
        // debug
        return super.post(`/api/CountryDataTimelineEvent`, countryDataTimelineEvent)
            .pipe(map((res: any) => {
                return res;
            }));
    }

    /**
     * Save the modified changes (as draft) and return the updated configset with correctly assigned IDs.
     * @param countryDataTimelineEvent
     */
    getTimeline(countryCode: string): Observable<CountryDataTimeline[]> {
        // debug
        return super.get(`/api/CountryDataTimelineEvent/timeline/${countryCode}`)
            .pipe(map((res: any) => res as CountryDataTimeline[]));
    }

}




